module.exports = __webpack_public_path__ + "static/img/2a.b90820c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2a.jpg
// module id = 5DPw
// module chunks = 0